import { Box, Typography, Link } from '@mui/material';
import FairtreeLogoDark from '../../resources/assets/images/bowlscout_logo_text_next.png';
import FairtreeLogo from '../../resources/assets/images/bowlscout_logo_text_next.png';
import { useColorMode } from '../../hooks/colorModeProvider';

const PoweredByBowlscout = ({ width }) => {
  const { mode } = useColorMode();

  return (
    <Box display={'flex'}>
      {/* <Link href="https://www.fairtree.com" target="_blank"> */}
      <img
        src={mode === 'dark' ? FairtreeLogoDark : FairtreeLogo}
        alt="Fairtree Logo"
        style={{ width: width ? width : '100px', height: 'auto' }}
      />
      {/* </Link> */}
    </Box>
  );
};

export default PoweredByBowlscout;
